import { IAtlasObjectRef } from '@common/helpers/atlasUrls'
import {
  IAtlasObjectDetailResponse,
  IGetAtlasObjectDetailParams,
  atlasObjectRefKey,
} from '@common/interfaces/atlasObjects'
import Base, { Wrapped } from './base'

export default class AtlasLinks extends Base {
  listObjectPreviews(refs: IAtlasObjectRef[]) {
    return this.apiClient.get('/atlas-links/previews', { refs: refs.map(atlasObjectRefKey) })
  }

  getObjectDetail({ type, id }: IGetAtlasObjectDetailParams) {
    return this.apiClient.get(`/atlas-links/${type}/${id}`) as Wrapped<IAtlasObjectDetailResponse>
  }
}
